import { Box, Group } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';
import { PriceOfferRow } from 'components/tables/data/price-offer/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the provider.
 */
export default function AssignedToColumn({ data }: { data: PriceOfferRow }) {
  return (
    <Group spacing={8} noWrap align="center">
      <Box w={24} h={24}>
        <IconUser stroke={1.5} height={24} width={24} />
      </Box>
      <P2Regular color="gray.8">{data.assignedTo.fullName}</P2Regular>
    </Group>
  );
}
